import { render, staticRenderFns } from "./MWorkspace.vue?vue&type=template&id=b4e01406&scoped=true&"
import script from "./MWorkspace.vue?vue&type=script&lang=ts&"
export * from "./MWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./MWorkspace.vue?vue&type=style&index=0&id=b4e01406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e01406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VTextField})
